import { render } from "./Setting4Channel.vue?vue&type=template&id=067f3692"
import script from "./Setting4Channel.vue?vue&type=script&lang=js"
export * from "./Setting4Channel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__